import * as React from 'react';
import { cn } from '@jobcost-monorepo/utils';

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  inputLeftElement?: React.ReactNode;
  inputRightElement?: React.ReactNode;
  width?: string;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (
    {
      className,
      inputLeftElement,
      inputRightElement,
      width = 'w-full',
      ...props
    },
    ref,
  ) => {
    return (
      <div className={cn('relative', width)}>
        {inputLeftElement && (
          <span className="absolute inset-y-0 left-0 flex items-center pl-2">
            {inputLeftElement}
          </span>
        )}
        <input
          className={cn(
            'block border py-2 px-3 w-full rounded-md border-purple70 text-sm shadow-sm focus:outline-purple70 text-ellipsis',
            !!inputLeftElement && `pl-7`,
            !!inputRightElement && 'pr-7',
            'text-ellipsis overflow-hidden whitespace-nowrap',
            'dark:bg-grey dark:text-white dark:border-purple dark:focus:outline dark:focus-visible:outline',
            className,
          )}
          autoComplete="new-password"
          ref={ref}
          {...props}
        />
        {inputRightElement && (
          <span className="absolute inset-y-0 right-0 flex items-center pr-1.5 cursor-pointer dark:text-white">
            {inputRightElement}
          </span>
        )}
      </div>
    );
  },
);
Input.displayName = 'Input';

export { Input };
